module.exports = __webpack_public_path__ + "img/review-2.085a1136.png";